<template>
  <span class="base-text-copy">
    <input
      ref="input"
      class="input"
      readonly
      type="text"
      v-model="value"
      @click.stop="onCopy"
    >
    <md-button
      class="copy-button md-raised md-primary"
      @click.stop.native="onCopy">
      <md-icon>content_copy</md-icon>
      <md-tooltip v-if="tooltip">{{ tooltip }}</md-tooltip>
    </md-button>
  </span>
</template>

<script>
export default {
  name: 'BaseTextCopy',
  props: {
    value: {
      type: String,
      default: ''
    },
    tooltip: String
  },
  methods: {
    onCopy () {
      if (this.$refs.input) {
        this.$refs.input.select()
        document.execCommand('copy')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.base-text-copy
  display: block
.input
  width: calc(100% - 120px)
  display: inline-block
  line-height: 26px
  vertical-align: bottom
.copy-button
  width: 80px
  margin-top: 6px
  background: none
  border: none
  border-bottom: 1px solid rgba(0,0,0,0.2)
  border-radius: 0
  padding: 0
  display: inline-block
  vertical-align: bottom
  position: relative
  top: 8px
</style>


// WEBPACK FOOTER //
// BaseTextCopy.vue?2e7ee1bc